<template>
    <div class="customl-section">
        <div class="customl-section-header">
            <h3>{{ getTranslations('expression_166') }}</h3>
            <button class="customl-add-tag-btn" @click="toggleNoteForm">
                <span class="customl-plus-icon">+</span> {{ getTranslations('expression_184') }}
            </button>
        </div>

        <!-- Formulário de Nota -->
        <div v-if="showNoteForm" class="customl-note-form">
            <div class="customl-note-type-selector">
                <label>{{getTranslations('expression_183')}}:</label>
                <select v-model="newNoteType" class="customl-note-type-select">
                    <option v-for="type in noteTypes" :key="type.id" :value="type.id">
                        {{ type.name }}
                    </option>
                </select>
            </div>
            <textarea v-model="newNote" class="customl-note-textarea" :placeholder="getTranslations('expression_570')"
                rows="3"></textarea>
            <div class="customl-note-actions">
                <button class="customl-note-cancel-btn" @click="cancelNoteForm">{{ getTranslations('expression_355') }}</button>
                <button class="customl-note-save-btn" @click="isEditingNote ? updateNote() : saveNote()"
                    :disabled="!newNote.trim()">
                    {{ isEditingNote ? getTranslations('expression_1408'): getTranslations('expression_120') }}
                </button>
            </div>
        </div>

       <!-- Lista de Notas -->
       <div v-if="filteredNotes.length > 0" class="customl-notes-container">
            <transition-group name="note-fade" tag="div" class="customl-notes-list">
                <div v-for="note in visibleNotes" :key="note.id" class="customl-note-item">

                    <div class="customl-note-header">
                        <div class="customl-note-type-badge" :class="getNoteTypeClass(note.type_key)">
                            {{ getNoteTypeLabel(note.type_key) }}
                        </div>
                        <div class="customl-note-date">
  <i class="bx bx-user mr-1"></i>
  {{ getUserObject('id', note.user_id).name }} 
  <span class="mx-1">|</span>
  <i class="bx bx-time mr-1"></i>
  {{ note.created }}
</div>

                        <!-- <div class="customl-note-actions-container">
                            <button class="customl-note-edit-btn" @click="editNote(note)" :title="getTranslations('expression_167')">
                                <i class="bx bx-pencil"></i>
                            </button>
                            <button class="customl-note-delete-btn" @click="deleteNote(note)" :title="getTranslations('expression_696')">
                                <i class="bx bx-trash"></i>
                            </button>
                        </div> -->
                    </div>
                    <div class="customl-note-content" :class="{ 'customl-note-truncated': isNoteTruncated(note) && !expandedNotes.includes(note.id) }">
                        {{ note.text }}
                    </div>
                    <div v-if="isNoteTruncated(note)" class="customl-note-expand">
                        <button 
                            class="customl-note-expand-btn" 
                            @click="toggleNoteExpansion(note.id)"
                        >
                            {{ expandedNotes.includes(note.id) ? getTranslations('expression_1409') : getTranslations('expression_63') }}
                            <i class="bx" :class="expandedNotes.includes(note.id) ? 'bx-chevron-up' : 'bx-chevron-down'"></i>
                        </button>
                    </div>
                </div>
            </transition-group>

            <!-- Controles de Paginação -->
            <div v-if="hasMoreToShow || showLessButton" class="customl-toggle-view">
                <button @click="hasMoreToShow ? loadMoreNotes() : showLessNotes()" class="customl-toggle-btn">
                    <span>{{ hasMoreToShow ? getTranslations('expression_63') : getTranslations('expression_1409') }}</span>
                    <i class="bx" :class="hasMoreToShow ? 'bx-chevron-down' : 'bx-chevron-up'"></i>
                </button>
            </div>


        </div>

        <!-- Mensagem sem notas -->
        <div v-else class="customl-no-notes-message">
            <i class="bx bx-info-circle"></i>
            <span>{{ getTranslations('expression_186') }}</span>
        </div>
    </div>
</template>

<script>
import { get } from "jquery";
import { mapGetters, mapState } from "vuex";
// import "../../assets/css/modals/ContactModal.css"
export default {
    name: "LeadNotes",
    props: {
        lead: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            showNoteForm: false,
            newNote: '',
            newNoteType: 0,
            isEditingNote: false,
            noteToEdit: null,
            showAllNotes: false,
            // initialNotesCount: 1,
            visibleCount: 1,
            currentPage: 1,
            perPage: 4,
            loadingNotes: false,
            expandedNotes: [], // Array para armazenar IDs de notas expandidas
            maxNoteLength: 150,

        };
    },
    mounted() {
        // if (this.lead?.id) {
        //     console.log("Buscando notas para lead ID:", this.lead.id);
        //     this.$store.dispatch('getNotesPage', { lead_id: this.lead.id }).then(() => {
        //         console.log("Notas carregadas:", this.notes.data);
        //     });
        // }
    },

    computed: {
        ...mapState(['notes', 'configs']),
        ...mapGetters([
            'getLeadCampaignsObject',
            'getChannelObject',
            'getTagsArray',
            'getTranslations',
            
        ]),
        // showPaginationControls() {
        //     return this.filteredNotes.length > this.initialNotesCount;
        // },
        filteredNotes() {
            return this.notes.pagination?.data?.filter(n =>
                n.lead_id === this.lead.id
            ) || [];
//             const all = this.notes.pagination?.data?.filter(n =>
//     n.lead_id === this.lead.id
//   ) || [];

//   const ids = new Set();
//   return all.filter(n => {
//     if (ids.has(n.id)) return false;
//     ids.add(n.id);
//     return true;
//   });
        }
        ,
        visibleNotes() {
            // console.log({
            //     total: this.notes.pagination?.total,
            //     filtered: this.filteredNotes.length,
            //     visibleCount: this.visibleCount,
            // });

            return this.filteredNotes.slice(0, this.visibleCount);
        },
        hasMoreToShow() {
            return this.visibleCount < (this.notes.pagination?.total || 0);
        },
        hasMoreNotesPages() {
            return (
                this.filteredNotes.length > 0 &&
                this.filteredNotes.length < (this.notes.pagination?.total || 0)
            )
        },
        showLessButton() {
            return !this.hasMoreToShow && this.visibleCount > 1;
        },


        noteTypes() {
            return this.configs?.data?.note_types || [];
        },
    },
    watch: {
    'lead.id': {  
      immediate: true,
      handler(newLeadId, oldLeadId) {
        if (newLeadId && newLeadId !== oldLeadId) {
          this.handleLeadChange({ id: newLeadId });
        }
      }
    }
    },
    methods: {
          // Método para verificar se uma nota deve ser truncada
          isNoteTruncated(note) {
            return note.text && note.text.length > this.maxNoteLength;
        },

        // Método para alternar a expansão de uma nota
        toggleNoteExpansion(noteId) {
            const index = this.expandedNotes.indexOf(noteId);
            if (index === -1) {
                // Adiciona o ID da nota ao array de notas expandidas
                this.expandedNotes.push(noteId);
            } else {
                // Remove o ID da nota do array de notas expandidas
                this.expandedNotes.splice(index, 1);
            }
        },
        async loadNotes() {
            await this.$store.dispatch('getNotesPage', {
                lead_id: this.lead.id,
                per_page: this.showAllNotes ? 100 : this.initialNotesCount
            });
        },
      async handleLeadChange(newVal) {
  if (!newVal?.id) return;

  const alreadyLoaded = this.notes.pagination?.data?.some(n => n.lead_id === newVal.id);
  if (alreadyLoaded) return;

  this.currentPage = 1;
  this.visibleCount = 1;
  this.loadingNotes = true;
  this.$store.commit('RESET_NOTES_PAGINATION');

  await this.$store.dispatch('getNotesPage', {
    lead_id: newVal.id,
    page: this.currentPage,
    per_page: this.perPage,
  });

  this.loadingNotes = false;
},

        async loadMoreNotes() {
            const total = this.notes.pagination?.total || 0;
            const alreadyLoaded = this.filteredNotes.length;

            // notas suficientes carregadas no state
            if (this.visibleCount + this.perPage <= alreadyLoaded) {
                this.visibleCount += this.perPage;
                return;
            }

            // senão, carrega mais do backend
            this.currentPage += 1;
            this.loadingNotes = true;
            try {
                await this.$store.dispatch('getNotesPage', {
                    lead_id: this.lead.id,
                    page: this.currentPage,
                    per_page: this.perPage,
                });


                const newFiltered = this.notes.pagination?.data?.filter(n => n.lead_id === this.lead.id) || [];
                this.visibleCount = Math.min(newFiltered.length, total);
            } catch (err) {
                console.error('Erro ao carregar mais notas:', err);
                this.currentPage -= 1;
            } finally {
                this.loadingNotes = false;
            }
        },

        showLessNotes() {
            this.visibleCount = 1;
            this.currentPage = 1;
            this.showAllNotes = false;
            // this.handleLeadChange(this.lead); // recarrega do início
        },

        // toggle pra mostrar as notas
        toggleShowAllNotes() {
            this.showAllNotes = !this.showAllNotes;
            this.loadNotes(); // recarrega as notas com quantidade adequada
        },
        toggleNoteForm() {
            this.showNoteForm = !this.showNoteForm;
            if (this.showNoteForm) {
                this.newNote = '';
                this.newNoteType = 0; // reset to default type
            }
        },

        // estilo de cor de cada tipo de nota
        getNoteTypeLabel(typeKey) {
            const noteType = this.noteTypes.find(type => type.id === typeKey);
            return noteType ? noteType.name : 'Geral';
        },

        getNoteTypeClass(typeKey) {
            switch (typeKey) {
                case 1: return 'customl-note-call';
                case 2: return 'customl-note-meeting';
                case 3: return 'customl-note-email';
                case 4: return 'customl-note-lunch';
                default: return 'customl-note-general';
            }
        },

        getNoteTypeIcon(typeKey) {
            const type = this.noteTypes.find(t => t.id === typeKey);
            return type?.icon || 'bx-note';
        },

        // Edit note method
        editNote(note) {
            this.isEditingNote = true;
            this.editingNoteId = note.id;
            this.newNote = note.text;
            this.newNoteType = note.type_key;
            this.showNoteForm = true;
        },

        // Cancel note form
        cancelNoteForm() {
            this.showNoteForm = false;
            this.isEditingNote = false;
            this.editingNoteId = null;
            this.newNote = '';
            this.newNoteType = 0;
        },

        // Update note method
        async updateNote() {
  if (!this.newNote.trim()) return;

  const payload = {
    id: this.editingNoteId,
    lead_id: this.lead.id,
    text: this.newNote,
    type_key: this.newNoteType
  };

  try {
    await this.$store.dispatch('updateNote', payload);

    // Resetar o formulário
    this.cancelNoteForm();

    // Atualizar as notas
    await this.$store.dispatch('getNotesPage', { lead_id: this.lead.id });

  } catch (error) {
    console.error("Erro ao atualizar nota:", error);
  }
},


        
        async saveNote() {
  if (!this.newNote.trim()) return;

  const payload = {
    lead_id: this.lead.id,
    text: this.newNote,
    type_key: this.newNoteType
  };

  try {
    await this.$store.dispatch('addNoteToast', payload);
    await this.$store.dispatch('getNotesPage', {
      lead_id: this.lead.id,
      page: 1,
      replace: true
    });
    // Resetar o formulário
    this.newNote = '';
    this.newNoteType = 0;
    this.showNoteForm = false;

    // Opcional: se quiser garantir que ela aparece já visível
    this.visibleCount = Math.max(this.visibleCount, 1);
    this.showAllNotes = true;

  } catch (error) {
    console.error("Erro ao adicionar nota:", error);

  }
}

,
// saveNote salvando notas localmente
// async saveNote() {
//     if (!this.newNote.trim()) return;

//     const payload = {
//         lead_id: this.lead.id,
//         text: this.newNote,
//         type_key: this.newNoteType
//     };

//     try {
//         const response = await this.$store.dispatch('addNoteToast', payload);
//         const now = new Date();
// const pad = (n) => n.toString().padStart(2, '0');

// const created = `${pad(now.getDate())}/${pad(now.getMonth() + 1)}/${now.getFullYear()} às ${pad(now.getHours())}:${pad(now.getMinutes())}h`;

//         // Criar um objeto de nota local com dados mínimos
//         const newLocalNote = {
//             id: Math.random().toString(36).substr(2, 9), // ID temporário
//             lead_id: this.lead.id,
//             text: this.newNote,
//             type_key: this.newNoteType,
//             created:created

            
//         };

//         // Adicionar localmente no começo do array
//         this.$store.state.notes.pagination.data.unshift(newLocalNote);

//         // Atualizar contagem e visibilidade
//         this.visibleCount++;
//         this.$store.state.notes.pagination.total++;

//         // Resetar formulário
//         this.newNote = '';
//         this.newNoteType = 0;
//         this.showNoteForm = false;

//         this.$swal.fire({
//             icon: 'success',
//             title: 'Anotação adicionada!',
//             timer: 1500,
//             position: 'bottom-end',
//             toast: true,
//             showConfirmButton: false
//         });
//     } catch (error) {
//         console.error("Erro ao adicionar nota:", error);
//         this.$swal.fire({
//             icon: 'error',
//             title: 'Erro ao adicionar a nota',
//             toast: true,
//             position: 'bottom-middle',
//             showConfirmButton: false,
//             text: error.message || 'Falha na criação da nota',
//             timer: 2000
//         });
//     }
// },

        
        async deleteNote(note) {
  try {
    await this.$store.dispatch('deleteNote', {
      id: note.id,
      lead_id: note.lead_id
    });


    await this.$store.dispatch('getNotesPage', { lead_id: note.lead_id });

    
    if (this.leadNotes.length <= this.initialNotesCount) {
      this.showAllNotes = false;
    }
  } catch (error) {
    console.error('Erro ao excluir nota:', error);
  }
},

    }
}
</script>

<style scoped>
/* Animation styles */
.note-fade-enter-active,
.note-fade-leave-active {
    transition: all 0.3s ease;
}

.note-fade-enter-from,
.note-fade-leave-to {
    opacity: 0;
    transform: translateY(10px);
}

/* Section header styles */
.customl-section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    flex-wrap: wrap;
    gap: 10px;
}

.customl-section-header h3 {
    font-size: 16px;
    font-weight: 600;
    margin: 0;
}

.customl-add-tag-btn {
    display: flex;
    align-items: center;
    gap: 4px;
    background: none;
    border: none;
    color: #1890ff;
    font-size: 14px;
    cursor: pointer;
    padding: 4px 8px;
    border-radius: 4px;
    transition: all 0.2s;
}

/* .customl-add-tag-btn:hover {
    background-color: rgba(24, 144, 255, 0.1);
} */

.customl-plus-icon {
    font-size: 16px;
}

/* Note form styles */
.customl-note-form {
    background-color: #f9f9f9;
    border: 1px solid #e8e8e8;
    border-radius: 8px;
    padding: 12px;
    margin-bottom: 16px;
}

.customl-note-type-selector {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
}

.customl-note-type-selector label {
    white-space: nowrap;
    font-size: 14px;
}

.customl-note-type-select {
    flex: 1;
    min-width: 120px;
    padding: 8px 12px;
    border-radius: 4px;
    border: 1px solid #ced4da;
    font-size: 14px;
}

.customl-note-textarea {
    width: 100%;
    padding: 10px;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    resize: vertical;
    font-family: inherit;
    font-size: 14px;
    margin-bottom: 12px;
}

.customl-note-textarea:focus {
    outline: none;
    border-color: #40a9ff;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}

.customl-note-actions {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    flex-wrap: wrap;
}

.customl-note-cancel-btn,
.customl-note-save-btn {
    padding: 6px 12px;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.2s;
    white-space: nowrap;
}

.customl-note-cancel-btn {
    background-color: white;
    border: 1px solid #d9d9d9;
    color: #666;
}

.customl-note-cancel-btn:hover {
    background-color: #f5f5f5;
    color: #333;
}

.customl-note-save-btn {
    background-color: #1890ff;
    border: 1px solid #1890ff;
    color: white;
}

.customl-note-save-btn:hover {
    background-color: #40a9ff;
    border-color: #40a9ff;
}

.customl-note-save-btn:disabled {
    background-color: #f5f5f5;
    border-color: #d9d9d9;
    color: #bfbfbf;
    cursor: not-allowed;
}

/* Note item styles */
.customl-notes-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.customl-note-item {
    background-color: #f8f9fa;
    border-radius: 8px;
    padding: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    transition: all 0.2s ease;
}

.customl-note-item:hover {
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
}

/* Improved note header with responsive layout */
.customl-note-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    flex-wrap: wrap;
    gap: 8px;
}

.customl-note-meta {
    display: flex;
    flex-direction: column;
    gap: 6px;
    flex: 1;
    min-width: 0; /* Important for text overflow to work */
}

.customl-note-type-badge {
    display: inline-block;
    font-size: 11px;
    padding: 3px 8px;
    border-radius: 12px;
    font-weight: 500;
    margin-right: 8px;
    white-space: nowrap;
}

.customl-note-date {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 3px;
    font-size: 11px;
    color: #6c757d;
}

.customl-note-user, 
.customl-note-time {
    display: flex;
    align-items: center;
    gap: 4px;
    white-space: nowrap;
}

.customl-note-separator {
    color: #adb5bd;
    display: inline-block;
}

.customl-note-date i {
    font-size: 14px;
}

/* Note type colors */
.customl-note-call {
    background-color: #e6f0ff;
    color: #1d4ed8;
}

.customl-note-meeting {
    background-color: #e6fffa;
    color: #099268;
}

.customl-note-email {
    background-color: #edf2ff;
    color: #722ed1;
}

.customl-note-lunch {
    background-color: #fff0f6;
    color: #d6336c;
}

.customl-note-general {
    background-color: #f1f3f5;
    color: #495057;
}

.customl-note-reminder {
    background-color: #fff4e6;
    color: #e67700;
}

/* Note content styles */
.customl-note-content {
    font-size: 14px;
    line-height: 1.5;
    color: #212529;
    word-break: break-word;
    transition: max-height 0.3s ease;
}

/* Truncated note styles */
.customl-note-truncated {
    max-height: 4.5em; /* Approximately 3 lines of text */
    overflow: hidden;
    position: relative;
}

.customl-note-truncated::after {
    content: '';
    position: absolute;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 1.5em;
    background: linear-gradient(to bottom, rgba(248, 249, 250, 0), rgba(248, 249, 250, 1));
}

/* Expand/collapse button */
.customl-note-expand {
    display: flex;
    justify-content: center;
    margin-top: 8px;
}

.customl-note-expand-btn {
    background: none;
    border: none;
    color: #1890ff;
    font-size: 12px;
    display: flex;
    align-items: center;
    gap: 4px;
    cursor: pointer;
    padding: 4px 8px;
    border-radius: 4px;
    transition: all 0.2s;
}

.customl-note-expand-btn:hover {
    background-color: rgba(24, 144, 255, 0.1);
}

.customl-note-expand-btn i {
    font-size: 14px;
}

/* Action buttons */
.customl-note-actions-container {
    display: flex;
    gap: 5px;
}

.customl-note-edit-btn,
.customl-note-delete-btn {
    background: none;
    border: none;
    color: #adb5bd;
    cursor: pointer;
    padding: 4px;
    transition: color 0.2s ease;
    border-radius: 4px;
}

.customl-note-edit-btn:hover {
    color: #1971c2;
    background-color: rgba(25, 113, 194, 0.1);
}

.customl-note-delete-btn:hover {
    color: #e03131;
    background-color: rgba(224, 49, 49, 0.1);
}

/* Empty state message */
.customl-no-notes-message {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 16px;
    background-color: #f8f9fa;
    border-radius: 8px;
    color: #6c757d;
    font-size: 14px;
    border: 1px dashed #dee2e6;
}

.customl-no-notes-message i {
    font-size: 18px;
    color: #adb5bd;
}

/* Pagination controls */
.customl-toggle-view {
    display: flex;
    justify-content: center;
    margin-top: 16px;
}

.customl-toggle-btn {
    background: none;
    border: none;
    color: #1890ff;
    font-size: 14px;
    display: flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
    padding: 6px 12px;
    border-radius: 16px;
    transition: all 0.2s ease;
}

.customl-toggle-btn:hover {
    background-color: rgba(24, 144, 255, 0.08);
}

.customl-toggle-btn i {
    font-size: 16px;
}

/* Responsive adjustments */
@media (min-width: 768px) {
    .customl-note-meta {
        flex-direction: row;
        align-items: center;
    }
    
    .customl-note-type-badge {
        margin-bottom: 0;
    }
}

@media (max-width: 480px) {
    .customl-note-date {
        flex-direction: column;
        align-items: flex-start;
        gap: 4px;
    }
    
    .customl-note-separator {
        display: none;
    }
    
    .customl-note-actions {
        justify-content: center;
    }
}
</style>
